/* src/app/shared/components/controls/button-divider/button-divider.component.scss */
.divider {
  color: lightgrey;
  margin: 0 1px;
}
/*# sourceMappingURL=button-divider.component-D5A5GWJ5.css.map */
